import LoopIcon from '@mui/icons-material/Loop';
import WebhookIcon from '@mui/icons-material/Webhook';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import SmsIcon from '@mui/icons-material/Sms';
import BackupIcon from '@mui/icons-material/Backup';
import EmailIcon from '@mui/icons-material/Email';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import FolderZipIcon from '@mui/icons-material/FolderZip';
import GradingIcon from '@mui/icons-material/Grading';
import MediationIcon from '@mui/icons-material/Mediation';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import HelpIcon from '@mui/icons-material/Help';

import { ReactComponent as SqlDbIcon } from '../../../assets/images/sqldb_icon.svg';
import { ReactComponent as MongodbIcon } from '../../../assets/images/mongodb_icon.svg';

export const getIconByType = (type_component) => {
    switch (type_component) {
        case 'parser':
            return <LoopIcon fontSize="large" style={{ color: '#CC33FF' }} />;
        case 'api_integration':
            return <WebhookIcon fontSize="large" style={{ color: '#FF6501' }} />;
        case 'decision':
            return <AltRouteIcon fontSize="large" style={{ color: '#5663ff' }} />;
        case 'sql_server':
            return <SqlDbIcon style={{ width: '32px', height: '32px' }} />;
        case 'notify_sms':
            return <SmsIcon fontSize="large" style={{ color: '#ff6464' }} />;
        case 's3_aws':
            return <BackupIcon fontSize="large" style={{ color: '#7b76ff' }} />;
        case 'email':
            return <EmailIcon fontSize="large" style={{ color: '#84C92D' }} />;
        case 'pdf':
            return <PictureAsPdfIcon fontSize="large" style={{ color: '#D32F2F' }} />;
        case 'zip_file':
            return <FolderZipIcon fontSize="large" style={{ color: '#FF8C00' }} />;
        case 'electronic_document':
            return <GradingIcon fontSize="large" style={{ color: '#007BFF' }} />;
        case 'mongo_db':
            return <MongodbIcon style={{ width: '32px', height: '32px' }} />;
        case 'analysis_document':
            return <MediationIcon fontSize="large" style={{ color: '#A52A2A' }} />;
        case 'whatsapp':
            return <WhatsAppIcon fontSize="large" style={{ color: '#25D366' }} />;
        case 'report':
            return <EqualizerIcon fontSize="large" style={{ color: '#c315c3' }} />;
        case 'sqs':
            return <LibraryBooksIcon fontSize="large" style={{ color: '#008080' }} />;
        case 'sftp':
            return <UploadFileIcon fontSize="large" style={{ color: '#FF1493' }} />;
        default:
            return <HelpIcon fontSize="large" style={{ color: '#696969' }} />;
    }
};